<h1 class="informacion-titulo">¡Bienvenidas y bienvenidos! </h1>

<p>El perfil Administrador permite trabajar con las siguientes áreas:</p>

<div style="padding-bottom: 20px;">
    <mat-accordion class="acordeon">
        <mat-expansion-panel #acordeon hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>1. Administrar Cuentas de Usuarios</h4>
                </mat-panel-title>
                <mat-panel-description>
                    <div>    
                        <mat-icon *ngIf="!acordeon.expanded">add_circle</mat-icon>
                        <mat-icon *ngIf="acordeon.expanded">remove_circle</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            
            <div class="contenido-acordeon">
                <p>
                    En esta sección es posible buscar, crear, editar, bloquear/desbloquear y asignar usuarios.
                </p>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<div style="padding-bottom: 20px;">
    <mat-accordion class="acordeon">
        <mat-expansion-panel  #acordeon2 hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>2. Ficha Jardín Infantil</h4>
                </mat-panel-title>
                <mat-panel-description>
                    <div>    
                        <mat-icon *ngIf="!acordeon2.expanded">add_circle</mat-icon>
                        <mat-icon *ngIf="acordeon2.expanded">remove_circle</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="contenido-acordeon">
                <p>
                    En esta sección es posible ver los principales datos de identificación del Jardín Infantil y visualizar información del Modelo de Gestión de Calidad de años anteriores.
                </p>
            </div>

        </mat-expansion-panel>
    </mat-accordion>
</div>
<div style="padding-bottom: 20px;">
    <mat-accordion class="acordeon">
        <mat-expansion-panel  #acordeon3 hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>3. Reporte y Datos de procesos</h4>
                </mat-panel-title>
                <mat-panel-description>  
                    <div>    
                        <mat-icon *ngIf="!acordeon3.expanded">add_circle</mat-icon>
                        <mat-icon *ngIf="acordeon3.expanded">remove_circle</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            
            <div class="contenido-acordeon">
                <p>
                    En esta sección es posible visualizar el estado de avance de los jardines infantiles en las distintas etapas dentro del modelo de gestión de calidad. 
                </p>
                <p>   
                    a) Consolidado: muestra un reporte consolidado en torno a todas las etapas.
                </p>
                <p>
                    b) Capacitación: muestra el estado de avance de capacitación y logro alcanzado. 
                </p>
                <p>
                    c) Autoevaluación: muestra el estado de avance de la autoevaluación, como resumen y como seguimiento detallado del proceso. 
                </p>
                <p>
                    d) Validación Externa: muestra el estado de avance del proceso de validación externa. 
                </p>
                <p>
                    e) Plan de Mejoramiento: muestra el estado de avance del proceso de Plan de Mejoramiento.
                </p>
            </div>

        </mat-expansion-panel>
    </mat-accordion>
</div>

<div style="padding-bottom: 20px;">
    <mat-accordion class="acordeon">
        <mat-expansion-panel  #acordeon3 hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>4. Mensajería</h4>
                </mat-panel-title>
                <mat-panel-description>  
                    <div>    
                        <mat-icon *ngIf="!acordeon3.expanded">add_circle</mat-icon>
                        <mat-icon *ngIf="acordeon3.expanded">remove_circle</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            
            <div class="contenido-acordeon">
                <p>
                    En esta sección permite establecer canales de comunicación con los jardines infantiles, como seguimiento detallado del proceso.
                </p>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>